import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'
import { emitContentMediaSelected, emitContentMediaBatchSelected } from "../utils/events"

export default class extends Controller {

  static values = {
    args: Object, // arguments à renvoyer avec l'event pour l'identifier chez le récepteur
    endpoint: String
  }

  get parentDialog() {
    return this.element.closest('[data-controller="dialog"]');
  }

  select(event) {
    const { id, action, editTransformedUrl, editId, editIsOwnEdit, url, ...file } = event.currentTarget.dataset;
    console.log('[media_selector] dataset:', event.currentTarget.dataset);
    console.log('[media_selector] editId:', editId, 'editIsOwnEdit:', editIsOwnEdit);
    const edit = editId ? { id: editId, transformedUrl: editTransformedUrl, isOwnEdit: editIsOwnEdit === 'true' } : null
    console.log('[media_selector] edit object:', edit);
    const { kind } = event.currentTarget.dataset;
    const contentMedium = { id, serialized_file: file, edit, url: url, thumbnail_url: url, media_type: file.resource_type, kind, 'editable?': file.resource_type == 'image' || kind === 'blueprint' }
    console.log('[media_selector] contentMedium:', contentMedium);
    emitContentMediaSelected(contentMedium, { to: this.parentDialog, ...this.argsValue });
    window.closeParentDialog(this.element);
  }


  async selectExternalSource(event) {
    const { url, thumbnailUrl, media_type, multipageUrls, canvaDesignId } = event.currentTarget.dataset;
    // canvaDesignId (absent hors Canva) déclenche ContentMedium#resolve_canva_remote_export ;
    // canva_page (numéro de page réel, fourni par le serveur) désambiguïse un multi-pages.
    const buildPayload = (pageUrl, page) => {
      const payload = { remote_medium_url: pageUrl };
      if (canvaDesignId) {
        payload.canva_design_id = canvaDesignId;
        if (page) payload.canva_page = page;
      }
      return payload;
    };
    // Pour le multipage Canva -> TODO: à refacto
    if (multipageUrls) {
      const multipage = JSON.parse(multipageUrls)
      if (multipage.length > 0) {
        multipage.forEach(async ({ url: pageUrl, page }) => {
          const body = JSON.stringify({ content_medium: buildPayload(pageUrl, page) })
          const res = await post('/content_media', { body, headers: { 'Accept': 'application/json' } })
          if (!res.ok) return console.error(`Échec de l'export Canva pour la page ${page}`)
          const { content_medium } = await res.json
          emitContentMediaSelected(content_medium, { to: this.parentDialog, ...this.argsValue })
        })
        return window.closeParentDialog(this.element);
      }
    }
    const body = JSON.stringify({ content_medium: buildPayload(url) })
    // en attendant d'en finir avec les provisional_id, on veut des int bien random
    const uuid = Math.floor(Math.random() * 1000000000000) + 1;
    emitContentMediaSelected({ url: thumbnailUrl, media_type }, { to: this.parentDialog, ...this.argsValue, uuid })
    window.closeParentDialog(this.element);
    const res = await post('/content_media', { body, headers: { 'Accept': 'application/json' } })
    if (!res.ok) return console.error("Échec de l'export Canva")
    const { content_medium } = await res.json
    emitContentMediaSelected(content_medium, { to: this.parentDialog, ...this.argsValue, uuid })
  }

  async onFileAdded(file, { batch, order } = {}) {
    const body = JSON.stringify({
      archive: 'true',
      content_medium: {
        medium: file.identifier + "#" + file.signature,
        kind: 'upload'
      },
    });
    const res = await post(this.endpointValue, {
      body,
      headers: { Accept: "application/json" },
    });

    const json = await res.json;
    const { content_medium } = json;

    // Le serveur ne retourne pas les métadonnées Cloudinary (duration, dimensions),
    // mais elles sont dans la réponse d'upload (objet `file` de buildUploadHandler).
    // On les merge ici pour que les listeners (ex: composition_editor) y aient accès.
    if (file.duration) content_medium.duration = file.duration;
    if (file.width) content_medium.width = file.width;
    if (file.height) content_medium.height = file.height;

    if (batch && content_medium?.id) this.batchMedia(batch).push({ order, content_medium });
    emitContentMediaSelected(content_medium, { to: this.parentDialog, ...this.argsValue, batch });
    return true;
  }

  // La fin du lot (file_uploader, une fois chaque fichier arrivé ou en échec) : les médias
  // créés, dans l'ordre de la sélection — pas celui de l'arrivée réseau. Qui veut le lot
  // entier (l'îlot du publisher) l'écoute ; l'événement par fichier reste pour les autres.
  batchSettled(batch) {
    const media = (this.batches?.get(batch) || [])
      .sort((a, b) => a.order - b.order)
      .map(({ content_medium }) => content_medium);
    this.batches?.delete(batch);
    emitContentMediaBatchSelected(media, { to: this.parentDialog, ...this.argsValue, batch });
  }

  batchMedia(batch) {
    this.batches ||= new Map();
    if (!this.batches.has(batch)) this.batches.set(batch, []);
    return this.batches.get(batch);
  }

  // La fermeture appartient à la FIN DU LOT, pas à chaque fichier.
  // `onFileAdded` est appelé une fois par photo ; fermer ici vidait le
  // turbo-frame (dialog_controller#resetFrame, déclenché dès que la modale
  // contient une vidéo), ce qui arrachait cet élément du DOM. L'outlet
  // `media-selector` de file_uploader_controller devenait alors introuvable, et
  // toutes les photos encore en vol tombaient dans son `return` silencieux.
  closeDialog() {
    window.closeParentDialog(this.element);
  }

}
